const TENANT = {
  GET_DEPOSITS: '/deposits',
  GET_DEPOSIT_SUMMARY_STAT: '/deposits/sum',
  GET_WITHDRAWALS: '/withdrawals',
  GET_WITHDRAWAL_SUMMARY_STAT: '/withdrawals/sum',
  GET_TRADES: '/trades',
  GET_TRADE_SUMMARY_STAT: '/trades/sum',
  GET_LIFE_TIME_TRADE_SUM: '/trades/life_time_trades_sum',
  GET_STAT: '/stats/life_time_values',
  GET_STOCKS: '/stocks'
} as const;

const USER = {
  GET_USERS: '/users',
  GET_USER_STAT: '/users/stat',
  GET_USER_COUNT: '/users/number_of_users',
  GET_USER_ACTIVITIES: '/users/user/:user_id',
  DOWNLOAD_CSV: '/:record/download_csv/'
} as const;

const PUBLIC_OFFERS = {
  GET_PORTFOLIOS: '/public-offers/portfolios',
  GET_PORTFOLIO: '/public-offers/portfolios/:id',
  GET_USER_PORTFOLIOS: '/public-offers/portfolios/user/:user_id'
} as const;

const AUTH = {
  TENANT_DETAILS: '/auth/admin'
} as const;

export { AUTH, USER, TENANT, PUBLIC_OFFERS };
